
import { ReactElement, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid, GridItem, GridProps, useDisclosure } from '@chakra-ui/react'
import { useAuth } from 'context'
import { AnimationProps, motion } from 'framer-motion'
import { themeColors } from 'theme'

import CustomDrawer from 'components/CustomDrawer'
import NavBar from 'components/NavBar'
interface AdminLayoutProps {
  children: ReactElement
}

type Props = Omit<GridProps, 'transition' | 'onAnimationStart' | 'onDragStart' | 'onDragEnd' | 'onDrag'>

const MotionGrid = motion<Props>(Grid)

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const history = useNavigate()
  const sidebar = useDisclosure()
  const { authState: { state: { user } } } = useAuth()
  const { container: { gradientColor: { gradientOne, gradientTwo, gradientThree } } } = themeColors

  useEffect(() => {
    if (!user) history('/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const AnimationSettings: AnimationProps = {
    transition: { duration: 0.5 },
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 }
  }

  return (
    <MotionGrid
      {...AnimationSettings}
      templateAreas={{ base: `"header" "main"`, md: `"header header" "nav main"` }}
      bgGradient={`linear(to-b, ${gradientOne}, ${gradientTwo}, ${gradientThree})`}
      templateRows={'70px 1fr'}
      templateColumns={{ base: '1fr', md: '320px 1fr' }}
      rowGap={4}
      minH='100vh'
      maxW='100vw'>
      <GridItem h="auto" area="header" position="sticky" top={0} zIndex="sticky">
        <NavBar sidebarOptions={sidebar} />
      </GridItem>
      <GridItem
        area='nav'
        w={'100%'}
        pl={4}
        pb={4}
        display={{ base: 'none', md: 'unset' }}>
        <CustomDrawer sidebarOptions={sidebar} />
      </GridItem>
      <GridItem
        alignItems='center'
        w='100%'
        area={'main'}
        px={4}
        pb={4}>
        {/* <Outlet /> */}
        {children}
      </GridItem>
    </MotionGrid>
  )
}

export default AdminLayout
